angular.module('unica_material.material_controllers')

.controller('MaterialListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, $uibModal,
	MaterialListService, MaterialDeleteService
) {

	$scope.materialList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.tiles = [];

	$scope.loadMaterials = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		MaterialListService
			.list( $stateParams.event_id, $scope.limit, $scope.offset )
			.then(function(data) {
				$scope.hideLoader();

				if ( !data.error ) {
					$scope.materialList = $scope.materialList.concat( data );

					if ( data.length === 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				}
			});
	};

	$scope.loadMaterials();

	$scope.openMaterialModal = function () {
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalMaterialInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/material.html',
			size: 'lg',
			windowClass: 'modal-material'
		});

		modalInstance.result.then(function (data) {
			$scope.loadMaterials();
		}, function () { });
	};

	$scope.deleteMaterial = function(materialId) {
		$confirm({
			title: 'Sei sicuro di voler eliminare il materiale?',
			text: 'Confermi la cancellazione del materiale?'
		}).then(function() {

			$scope.showLoader();
			MaterialDeleteService
				.delete( materialId )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.materialList, function(material, key) {
							if ( material.id == materialId ) {
								$scope.materialList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Materiale eliminato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});
	};

	$scope.showDelete = true;
	if ( sessionStorage.getItem('from_admin_archive') ) {
		sessionStorage.removeItem('from_admin_archive');
		$scope.showDelete = false;
	}
})


.controller('ModalMaterialInstanceController',
	function (
		$scope, $stateParams,
		$uibModalInstance, FileUploader, getBaseApiURL, Session
	) {

	$scope.materialData = {
		files: []
	};

	$scope.uploadDone = false;

	$scope.uploader = new FileUploader({
		alias: 'files',
		url: getBaseApiURL + '/material/upload',
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});

	$scope.uploader.formData.push({ 'event_id' : $stateParams.event_id });

	$scope.uploader.onCompleteAll = function() {
		$scope.uploadDone = true;
	};

	$scope.createMaterials = function () {
		$scope.uploader.uploadAll();
	};

	$scope.closeModal = function() {
		if ( $scope.uploadDone ) {
			$uibModalInstance.close();
		} else {
			$uibModalInstance.dismiss('cancel');
		}
	};

	$scope.triggerInput = function() {
		setTimeout(function() {
			document.getElementById('files').click()
		}, 0);
	};

});